module.exports = "images/view2.jpg";